/*
 * @Description: 文件说明
 * @Author: XSYX
 * @Date: 2026-02-12 16:49:32
 * @LastEditors: XSYX
 * @LastEditTime: 2026-05-27 11:44:11
 * @FilePath: \smkp1\src\store\index.js
 */
import vuex from "vuex";
import vue from "vue";
vue.use(vuex);

const store = new vuex.Store({
  state: {
    dhInfo: {}, //单号信息
    fpInfo: {}, //发票信息
    InvoiceInfo: {}, //发票信息
    FPZL: "", //当前发票种类
    isHP: false, //是否是换票
    allFpzl: "", //全部的发票总类
    gsInfo: {}, //公司信息
  },
  mutations: {
    dhInfo(state, data) {
      state.dhInfo = data;
    },
    fpInfo(state, data) {
      state.fpInfo = data;
    },
    InvoiceInfo(state, data) {
      state.InvoiceInfo = data;
    },
    FPZL(state, data) {
      state.FPZL = data;
    },
    isHP(state, data) {
      state.isHP = data;
    },
    allFpzl(state, data) {
      state.allFpzl = data;
    },
    gsInfo(state, data) {
      state.gsInfo = data;
    },
  },
});

export default store;
